<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import PartroomMark from '@/components/base/PartroomMark.vue'
import { APP_VERSION } from '@/appVersion'

/**
 * Linke Brand-Saeule fuer Auth-Seiten (Login, Forgot-Password,
 * Reset-Password). Wird von einem `.auth-shell-brand`-Wrapper umgeben,
 * der das 2-Spalten-Grid liefert (siehe _auth-shared.css).
 *
 * Identische Animationen wie im LoginView; die CSS-Klassen `.lb-*` werden
 * dort global definiert, damit beide Komponenten denselben Look haben
 * ohne den Code zu duplizieren.
 */
const { t } = useI18n()
</script>

<template>
  <section class="login-brand auth-brand-panel">
    <div class="lb-deco" aria-hidden="true">
      <svg class="dial" viewBox="0 0 440 440">
        <g class="dial-rot" fill="none" stroke="currentColor">
          <circle cx="220" cy="220" r="210" stroke-width="1" opacity="0.35" />
          <circle cx="220" cy="220" r="168" stroke-width="1" opacity="0.5" />
          <circle cx="220" cy="220" r="120" stroke-width="1" opacity="0.7" />
          <line
            v-for="i in 60"
            :key="i"
            x1="220"
            y1="12"
            x2="220"
            :y2="(i - 1) % 5 === 0 ? 26 : 19"
            :stroke-width="(i - 1) % 5 === 0 ? 1.6 : 1"
            :opacity="(i - 1) % 5 === 0 ? 0.8 : 0.4"
            :transform="`rotate(${(i - 1) * 6} 220 220)`"
          />
        </g>
      </svg>
      <span class="lb-glow"></span>
    </div>

    <div class="lb-content">
      <div class="lb-logo" aria-label="Partroom"><PartroomMark /></div>
      <div class="lb-word">Part<em>room</em></div>
      <p class="lb-tag">{{ t('login.sub') }}</p>
    </div>

    <div class="lb-foot">© 2026 Partroom · {{ APP_VERSION }}</div>
  </section>
</template>
